import { render, staticRenderFns } from "./SuggestedVideo.vue?vue&type=template&id=8b087428&scoped=true&"
import script from "./SuggestedVideo.vue?vue&type=script&lang=js&"
export * from "./SuggestedVideo.vue?vue&type=script&lang=js&"
import style0 from "./SuggestedVideo.vue?vue&type=style&index=0&id=8b087428&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b087428",
  null
  
)

/* custom blocks */
import block0 from "./SuggestedVideo.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports